import { render, staticRenderFns } from "./xl-sas.vue?vue&type=template&id=4fb659d4&scoped=true"
import script from "./xl-sas.vue?vue&type=script&lang=js"
export * from "./xl-sas.vue?vue&type=script&lang=js"
import style0 from "./xl-sas.vue?vue&type=style&index=0&id=4fb659d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb659d4",
  null
  
)

export default component.exports